<template>
  <div class="container">
    <div v-if="loading" class="loading">
      <van-loading size="24px" color="#1989fa" vertical>加载中...</van-loading>
    </div>
    <div class="video-list">
      <div
        class="item"
        v-for="item in dataList"
        :key="item.id"
        @click="detailList(item)"
      >
        <van-image
          width="100"
          height="100"
          fit="contain"
          :src="item.product_img"
        />
        <div class="name">{{ item.product_name }}</div>
        <div class="count">{{ item.videoCount }}个</div>
        <van-icon name="arrow" />
      </div>
    </div>
  </div>
</template>

<script>
import { pList } from "@/api/video";
export default {
  name: "VideoIndex",
  data() {
    return {
      loading: true,
      dataList: [],
    };
  },
  mounted() {
    this.loadData();
  },
  methods: {
    loadData() {
      this.loading = true;
      pList()
        .then((res) => {
          console.log(res);
          if (res.code) {
            this.dataList = res.data;
            this.success = true;
          } else {
            this.$toast(res.message);
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    detailList(item) {
      if (item.res_type == 1) {
        this.videoList(item);
      } else {
        this.resList(item);
      }
    },
    videoList(item) {
      this.$router.push({
        name: "videoList",
        params: {
          pId: item.id,
          title: item.product_name,
        },
      });
    },
    resList(item) {
      this.$router.push({
        name: "resList",
        params: {
          pId: item.id,
          title: item.product_name,
        },
      });
    },
  },
};
</script>

<style lang="less" scoped>
.container {
  height: 100%;
  .loading {
    width: 100%;
    height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .video-list {
    height: 100vh;
    padding-top: 16px;

    .item {
      display: flex;
      align-items: center;
      background-color: #fff;
      padding: 12px;
      border-radius: 10px;
      margin: 0 12px 16px 12px;

      &:active {
        background-color: #f8f8f8;
      }

      .name {
        flex: 1;
        font-size: 15px;
        font-weight: bold;
        color: #333;
        margin: 0 12px;
      }
      .count {
        font-size: 13px;
        color: #2f54eb;
      }
    }
  }
}
</style>